var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.5V20.25C22.5 21.4927 21.4927 22.5 20.25 22.5H3.75C2.50734 22.5 1.5 21.4922 1.5 20.25V7.5H9V12.75C9 13.1625 9.3375 13.5 9.75 13.5H14.25C14.6625 13.5 15 13.1625 15 12.75L14.9578 7.5H22.5Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58422 1.5C4.93359 1.5 4.36547 1.91016 4.16016 2.52562L1.51758 7.44375C1.52637 7.45547 1.53223 7.46367 1.53809 7.47188C1.54395 7.48008 1.5498 7.48828 1.55859 7.5H9V12.75C9 13.2 9.3 13.5 9.75 13.5H14.25C14.7 13.5 15 13.2 15 12.75L14.9578 7.5H9L10.5 1.5H5.58422ZM19.8422 2.52562C19.6359 1.91016 19.0688 1.5 18.4172 1.5H13.5L14.9986 7.5H22.4423C22.4511 7.48828 22.457 7.47949 22.4629 7.4707C22.4687 7.46191 22.4746 7.45312 22.4834 7.44141L19.8422 2.52562Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.69d3fb916fa0184f6c283e2099d3dd8d.svg";
export { ForwardRef as ReactComponent };